/* eslint-disable */
import React from 'react';
import Banner from '../components/Banner';
import UpdatesBlock from '../components/UpdatesBlock';
import '../css/HomePage.css';
import NewsroomMenu from '../components/NewsroomMenu';

/**
 * This function renders the Home page
 * @component HomePage
 * @return {Component} HomePage component
 */
export default function HomePage() {
  return (
    <React.Fragment>
      <Banner />
      <br />
      <br />
      <NewsroomMenu />
      <br />
      <br />
      <UpdatesBlock />
    </React.Fragment>
  );
}
